export { PageTemplate } from './page'